export default "<div class=\"main\">\n  <div class=\"main__inner\">\n    <router-outlet></router-outlet>\n  </div>\n</div>\n"